module.exports = __webpack_public_path__ + "925e09ebc35bf21aa61fafd690e1a8bc.png";